"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flatIndex = undefined;

var _videoIndex = require("program/video-index.json");

var _videoIndex2 = _interopRequireDefault(_videoIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var flatIndex = [];

function processGroup(gr) {

  gr.forEach(function (it) {

    if (it.type === "group") processGroup(it.contents);

    if (it.type === "video") flatIndex.push(it);
  });
}

processGroup(_videoIndex2["default"].root);

exports.flatIndex = flatIndex;


//////////////////
// WEBPACK FOOTER
// ./program/flat-index.js
// module id = 942
// module chunks = 0